import React, { Suspense } from 'react'
import { Switch, Route, BrowserRouter } from 'react-router-dom'
import { Modal, ModalProvider } from '../Layout/Modal'
import WebinarAudienceRoomRoutesComponent from './WebinarAudienceRoomRoutesComponent'
import WebinarProducerRoutesComponent from './WebinarProducerRoutesComponent'

const Router = () => (
  <BrowserRouter>
    <Suspense fallback={null}>
      <ModalProvider>
        <Switch>
          <Route path="/webinar" component={WebinarProducerRoutesComponent} />
          <Route component={WebinarAudienceRoomRoutesComponent} />
        </Switch>
        <Modal />
      </ModalProvider>
    </Suspense>
  </BrowserRouter>
)

export default Router
